var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.profile.creatorRequests),function(creatorRequest){return _c('div',{key:creatorRequest.id,staticClass:"p-2 bg-light",on:{"click":function($event){return _vm.closeProfileAndRedirectToRequestView(creatorRequest)}}},[_c('creator-request-index-item',{attrs:{"creatorRequest":creatorRequest}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }